import React from 'react';
import { useTranslations } from '../translations';
import './AccountTooltip.css';

interface AccountTooltipProps {
  visible: boolean;
  isLoggedIn?: boolean;
  onNavigateToLogin: () => void;
  onNavigateToRegister: () => void;
  onLogout?: () => void;
}

const AccountTooltip: React.FC<AccountTooltipProps> = ({ visible, isLoggedIn = false, onNavigateToLogin, onNavigateToRegister, onLogout }) => {
  const t = useTranslations();
  if (!visible) return null;

  if (isLoggedIn) {
    return (
      <div className="account-tooltip">
        <div className="tooltip-background">
          <div className="tooltip-actions">
            <button className="tooltip-btn-tertiary" onClick={onLogout}>
              Deconectare
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="account-tooltip">
      <div className="tooltip-background">
        <p className="tooltip-description">
          {t.accountTooltip.description}
        </p>
        <div className="tooltip-actions">
          <button className="tooltip-btn-primary" onClick={onNavigateToLogin}>
            {t.accountTooltip.loginButton}
          </button>
          <button className="tooltip-btn-tertiary" onClick={onNavigateToRegister}>
            {t.accountTooltip.noAccountButton}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountTooltip;
